import script from "./PaTour.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaTour.vue?vue&type=script&setup=true&lang=ts"

import "./PaTour.vue?vue&type=style&index=0&id=3d3d91a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d3d91a2"]])

export default __exports__